export enum AnimeEasingOptions {
    LINEAR = 'linear',
    EASE_IN_QUAD = 'easeInQuad',
    EASE_IN_CUBIC = 'easeInCubic',
    EASE_IN_QUART = 'easeInQuart',
    EASE_IN_QUINT = 'easeInQuint',
    EASE_IN_SINE = 'easeInSine',
    EASE_IN_EXPO = 'easeInExpo',
    EASE_IN_CIRC = 'easeInCirc',
    EASE_IN_BACK = 'easeInBack',
    EASE_IN_ELASTIC = 'easeInElastic',
    EASE_IN_BOUNCE = 'easeInBounce',
    EASE_OUT_QUAD = 'easeOutQuad',
    EASE_OUT_CUBIC = 'easeOutCubic',
    EASE_OUT_QUART = 'easeOutQuart',
    EASE_OUT_QUINT = 'easeOutQuint',
    EASE_OUT_SINE = 'easeOutSine',
    EASE_OUT_EXPO = 'easeOutExpo',
    EASE_OUT_CIRC = 'easeOutCirc',
    EASE_OUT_BACK = 'easeOutBack',
    EASE_OUT_ELASTIC = 'easeOutElastic',
    EASE_OUT_BOUNCE = 'easeOutBounce',
    EASE_IN_OUT_QUAD = 'easeInOutQuad',
    EASE_IN_OUT_CUBIC = 'easeInOutCubic',
    EASE_IN_OUT_QUART = 'easeInOutQuart',
    EASE_IN_OUT_QUINT = 'easeInOutQuint',
    EASE_IN_OUT_SINE = 'easeInOutSine',
    EASE_IN_OUT_EXPO = 'easeInOutExpo',
    EASE_IN_OUT_CIRC = 'easeInOutCirc',
    EASE_IN_OUT_BACK = 'easeInOutBack',
    EASE_IN_OUT_ELASTIC = 'easeInOutElastic',
    EASE_IN_OUT_BOUNCE = 'easeInOutBounce',
}
